import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

type FalsyOf<T> = T extends true
	? never
	: T extends boolean
		? false
		: T extends number
			? 0
			: T extends string
				? ""
				: T extends null
					? null
					: T extends any[]
						? never
						: T extends object
							? never
							: undefined;

/**
 * A filter which removes truthy values. The equivalent falsy types of the filtered type will also be inferred, for
 * example: the falsy type for string is literal "", for number it is literal 0, for boolean it is literal false,
 * and for the rest it is literal undefined.
 *
 * ```ts
 * this.store.pipe(select(this.selector.isBusy), ignoreTruthy())
 * ```
 *
 * @return An Observable that only emits falsy values.
 */
export const ignoreTruthy =
	() =>
	<T>(source: Observable<T>) =>
		source.pipe(filter((input) => !input)) as Observable<FalsyOf<T>>;
